<template>
  <div :class="{center_loading: center}">
    <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
  </div>
</template>
<script>
export default {
  name: "Loading",
  props: {
    center: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style scoped>
.center_loading {
  text-align: center;
  padding: 30px;
  font-size: 40px;
}
</style>
